import registry from "~/components/DoRegistry.js";

var template = require("./modal.hbs");

var sizes = {
    small: {
        width: '350px',
        height: 'auto'
    },
    medium: {
        width: '650px',
        height: '450px'
    },
    large: {
        width: '85%',
        height: '80%'
    }
}


class DoModal{
    constructor(uniqueName, content, settingsOrSizeName, isBBI){
        this.id = uniqueName;

        if($.type(content) !== 'string'){
            this.$content = content;
            content = null;
        }

        var self = this;
        var tplData = $.extend(true, {id:this.id, content:content, ok:"OK", cancel: "Cancel", bbi: isBBI}, sizes.medium, sizes[settingsOrSizeName], settingsOrSizeName);

        this.$dom = $(template(tplData));

        $(document).ready(()=>{

            this.$dom.find(".fancybox-close").click(()=>{this.cancel()});

            this.$dom.find('.modal-ok button').click(()=>{this.ok()});
            this.$dom.find('.modal-cancel button').click(()=>{this.cancel()});

            if(this.$content){
                this.content(this.$content);
            }

            $(document.body).append(this.$dom);
        });
    }

    cancel(){
        if(this.cancelCb){
            this.cancelCb();
        }else{
            this.hide();
        }
    }

    ok(){
        if(this.okCb){
            this.okCb();
        }else{
            this.hide();
        }
    }

    content(content){
        this.$dom.find('.fancybox-inner').html(content);
    }

    getContentContainer(){
        return this.$dom.find('.fancybox-inner');
    }

    show(okCb, cancelCb){
        this.okCb = okCb;
        this.cancelCb = cancelCb;

        this.okCb ? this.$dom.find('.modal-ok').show() : this.$dom.find('.modal-ok').hide();

        $('#'+this.id+"_modal").css('z-index', DoModal.prototype.zindex+1).css('top', DoModal.prototype.offset+"%");
        $('#'+this.id+"_overlay").css("z-index", DoModal.prototype.zindex);

        this.$dom.show();

        DoModal.prototype.offset = DoModal.prototype.offset + 2;
        DoModal.prototype.zindex = DoModal.prototype.zindex + 20;
    }

    hide(){
        this.$dom.hide();
        DoModal.prototype.offset = DoModal.prototype.offset - 2;
        DoModal.prototype.zindex = DoModal.prototype.zindex - 20;
    }

    destroy(){
        this.$dom.remove();
    }
}

//store some "global" values on prototype.  This allows multiple modals
if(!DoModal.prototype.offset){
    DoModal.prototype.offset = 9;
    DoModal.prototype.zindex = 999999;
}

registry.register(__filename, DoModal);
export default DoModal;